/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

// import NewContentList from './NewContentList'

import Event202110_contentList from "./Event202110_contentList";

//import '../../css/event210621.css'

import "../../css/event210926.css";

import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import {isMobile} from 'react-device-detect';

class Event202110_newContent extends Component {
  state = {
    eventCode: 0,
    grade: 1,
    kecode: "",
    show: false,
  };
  componentDidMount = () => {
    this._makeKeycode();
  };

  _goVod = (code) => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    if (code === "4" || code === "5") {
      history.push("/list?q=tag&c=" + code);
    } else {
      history.push("/list?q=genre&c=" + code);
    }
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _pass = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push("/ticket");
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    let os = "";

    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );

    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        os = "android";
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1
      ) {
        os = "ios";
      } else {
        os = "otehr";
      }
    } else {
      os = "pc";
    }

    if (today <= "2021-03-31 00:00:00") {
      toast.warn("3월 31일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      if (os === "pc") {
        setTimelineWeek(true);
      } else {
        if (os === "ios") {
          setTimeout(function () {
            window.open("https://apps.apple.com/kr/app/id687631772", "", "");
          }, 1500);

          window.location.href = "aniplustv://TimeTable";
        } else {
          //setTimeout(function () {
          //window.open(android_appstore_url);
          //}, 1500);

          window.location.href = "aniplustv://TimeTable";
        }

        //this.action_app('aniplustv://TimeTable', 'aniplustv://TimeTable', 'https://itunes.apple.com/kr/app/instagram/id687631772', 'https://play.google.com/store/apps/details?id=com.aniplustv.android')
      }
    }
  };
  _goGoogle = () => {
    window.open("https://forms.gle/Ja6XA3mKH3rCfL6s7", "", "");
  };

  _setGrade = (grade) => {
    this.setState({
      grade,
    });

    if (grade === 3) {
      //alert('백신증명서....')
      this._licens();
    }
  };
  _makeKeycode = () => {
    const keycode = Math.random().toString(36).substr(2, 11);

    this.setState({
      keycode: keycode,
    });
  };

  _licens = async () => {
    const result = await this._licensApi();
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        list,
        show: true,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("1, 2차 신작백신을 접종 후 확인이 가능합니다.");
    }
  };
  _licensApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202110_list", {
      params: {},
    });
  };
  _licensClose = () => {
    this.setState({
      show: false,
    });
  };
  render() {
    const { keycode, show, list } = this.state;
    // const bgImg = '//img/event/20210317/bg.png'
    const curDate = new Date();
    // const today = moment(curDate).format('YYYY-MM-DD HH:mm:ss')

    return (
      <Fragment>
        <div className="pop210926" style={{ display: show ? "" : "none" }}>
          <div className="popup">
            <a
              className="close"
              alt="닫기"
              style={{ cursor: "pointer" }}
              onClick={this._licensClose}
            ></a>
            <div className="pop_con">
              <dl className="num">
                <dt>백신 접종넘버</dt>
                <dd>{list ? list[0].idx : null}</dd>
              </dl>
              <dl className="date">
                <dt>증명서 발급일자</dt>
                <dd>{moment(curDate).format("YYYY.MM.DD")}</dd>
              </dl>
              <dl className="ani">
                <dt>기대작품</dt>
                <dd>
                  <p>1차 : {list ? list[0].title : null} </p>
                  <p>
                    2차 :{" "}
                    {list ? (list.length >= 1 ? list[1].title : null) : null}{" "}
                  </p>
                  <div className="img">
                    {list ? <img src={list[0].img} /> : null}
                    {list ? (
                      list.length >= 1 ? (
                        <img src={list[1].img} />
                      ) : null
                    ) : null}
                  </div>
                </dd>
              </dl>
              <a
                className="link"
                href="#"
                alt="신작 백신 접종 증명서 발급받기"
              ></a>
            </div>
            <img src="/img/event/event210926/popup.png" className="bg" />
          </div>
        </div>

        <div className="event_head">
          {/*<button type="button" onclick="history.back()"><img src="/img/event/back.png" alt="뒤로"/></button>*/}
          <h3>애니플러스 신작 이벤트</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event210926">
            <div className="sticky">
              <div className="quick">
                <a href="#eventIn">
                  <img src="/img/event/event210926/quick_01.png" alt="top" />
                </a>
                <a href="#newList">
                  <img
                    src="/img/event/event210926/quick_02.png"
                    alt="신작목록"
                  />
                </a>
                <a href="#gift">
                  <img src="/img/event/event210926/quick_03.png" alt="경품" />
                </a>
                <a style={{ cursor: "pointer" }} onClick={this._timeTable}>
                  <img
                    src="/img/event/event210926/quick_04.png"
                    alt="요일별시간표"
                  />
                </a>
                <a href="#comment">
                  <img src="/img/event/event210926/quick_05.png" alt="댓글" />
                </a>
              </div>
            </div>
            <div className="main">
              <img
                src="/img/event/event210926/backimg_1.png"
                alt="2021 애니플러스 4분기 신작 이벤트"
                className="img_web"
              />
              <img
                src="/img/event/event210926/backimg_m1.png"
                alt="2021 애니플러스 4분기 신작 이벤트"
                className="img_m"
              />
              <div className="obj">
                <img src="/img/event/event210926/main_obj.png" />
              </div>
              {/*<a onClick={this._goGoogle} className="link" name="top" style={{ cursor: 'pointer'}}></a>
                          
                            <div className="peng"><img src="/img/event/event210621/peng.png"/></div>*/}
            </div>
            <div className="mission">
              <div className="listWrap">
                <h2 className="tit">
                  <img
                    src="/img/event/event210926/list_tit01.png"
                    alt="1차 신작 백신 접종 미션"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event210926/m_list_tit01.png"
                    alt="1차 신작 백신 접종 미션"
                    className="img_m"
                  />
                </h2>
                <a className="link" name="newList"></a>

                <Event202110_contentList
                  eventCode={1}
                  keycode={keycode}
                  _setGrade={this._setGrade}
                  _makeKeycode={this._makeKeycode}
                />
                <Event202110_contentList
                  eventCode={2}
                  keycode={keycode}
                  _setGrade={this._setGrade}
                  _makeKeycode={this._makeKeycode}
                />
                <h2 className="tit">
                  <img
                    src="/img/event/event210926/list_tit02.png"
                    alt="1차 신작 백신 접종 미션"
                    class="img_web"
                  />
                  <img
                    src="/img/event/event210926/m_list_tit02.png"
                    alt="1차 신작 백신 접종 미션"
                    class="img_m"
                  />
                </h2>

                <Fragment>
                  <Event202110_contentList
                    eventCode={3}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                  />
                  <Event202110_contentList
                    eventCode={4}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                  />
                  <Event202110_contentList
                    eventCode={5}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                  />
                  <Event202110_contentList
                    eventCode={6}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                  />
                </Fragment>
              </div>

              <div className="listWrap">
                {/*
                                    <h2 className="tit">
                                        <img src="/img/event/event210926/list_tit02.png" alt="1차 신작 백신 접종 미션" class="img_web"/>
                                        <img src="/img/event/event210926/m_list_tit02.png" alt="1차 신작 백신 접종 미션" class="img_m"/>
                                    </h2>
                                   
                                    <ul className="list">
                                        <li className="comming">
                                            2021.09.29일 접종 시작합니다!
                                        </li>
                                    </ul>
                                     */}
              </div>
            </div>

            <div className="gift">
              <a
                className="link"
                style={{ cursor: "pointer" }}
                onClick={this._timeTable}
                name="gift"
              ></a>
              <img
                src="/img/event/event210926/backimg_3.png"
                alt="경품내용 및 주의사항"
                className="img_web"
              />
              <img
                src="/img/event/event210926/backimg_m3.png"
                alt="경품내용 및 주의사항"
                className="img_m"
              />
            </div>

            <div className="btm_btn">
              <a
                onClick={this._licens}
                className="link"
                alt="신작 백신 증명서 확인하기"
                style={{ cursor: "pointer" }}
                name="eventIn"
              ></a>
              <a
                onClick={this._goGoogle}
                className="link"
                alt="신작 백신 인증샷 응모하기"
                style={{ cursor: "pointer" }}
              ></a>
              <img
                src="/img/event/event210926/backimg_4.png"
                alt="하단 버튼"
                className="img_web"
              />
              <img
                src="/img/event/event210926/backimg_m4.png"
                alt="하단 버튼"
                className="img_m"
              />
            </div>
            {/*
                        <div className="btm" >
                            <a onClick={this._timeTable} className="link" name="gift" style={{ cursor: 'pointer'}}></a>
                            <img src="/img/event/event210621/backimg_2.png" alt="경품내용 및 주의사항" className="img_web"/>
                            <img src="/img/event/event210621/backimg_m2.png" alt="경품내용 및 주의사항" className="img_m"/>
                        </div>
                        */}
          </div>
        </div>
        <a href="#" name="comment"></a>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202110_newContent));
